import { defineComponent as l, createBlock as e, openBlock as r, normalizeProps as a, mergeProps as t, withCtx as p, renderSlot as s } from "vue";
import n from "./ClassicLayout.vue.js";
import m from "./ModernLayout.vue.js";
const c = /* @__PURE__ */ l({
  __name: "Tag",
  props: {
    tag: {},
    layout: {},
    moreThanOneTag: { type: Boolean }
  },
  setup(u) {
    return (o, f) => o.layout === "classic" ? (r(), e(n, a(t({ key: 0 }, o.$props)), {
      default: p(() => [
        s(o.$slots, "default")
      ]),
      _: 3
    }, 16)) : (r(), e(m, a(t({ key: 1 }, o.$props)), {
      default: p(() => [
        s(o.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
export {
  c as default
};
